module.exports = __webpack_public_path__ + "img/16.6690ad21.png";